export function updateGridLayer(layer, props, prevProps) {
  var opacity = props.opacity,
    zIndex = props.zIndex;
  if (opacity != null && opacity !== prevProps.opacity) {
    layer.setOpacity(opacity);
  }
  if (zIndex != null && zIndex !== prevProps.zIndex) {
    layer.setZIndex(zIndex);
  }
}